import { render } from "./Modal.vue?vue&type=template&id=00610eba"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=00610eba&lang=scss"
script.render = render

export default script